import type { PropsWithChildren } from 'react'

export function AuthShell({ children }: PropsWithChildren) {
  return (
    <main className="relative min-h-screen overflow-hidden bg-[var(--app-bg)]">
      <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-[var(--color-accent)]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 h-[28rem] w-[28rem] rounded-full bg-[var(--color-secondary)]/20 blur-3xl" />

      <div className="relative mx-auto flex min-h-screen w-full max-w-md items-center px-6 py-10">
        {children}
      </div>
    </main>
  )
}
